import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kandivalitopunecab() {



const cardData = {
  keyword: " Kandivali to Pune Cab ",

headingDescription: "Velocity Cab provides reliable and comfortable Kandivali to Pune cab services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Kandivali to Pune convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Kandivali to Pune cab travel.",

topPlaces: [
    {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva, carved from a single basalt rock. It is known for its unique architecture and peaceful spiritual environment."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum houses a vast collection of Indian antiques, musical instruments, sculptures, and cultural artifacts. It provides a rich insight into India’s traditional art and heritage."
  },
  {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden, also known as Pu La Deshpande Garden, is a beautifully maintained Japanese-style garden featuring serene landscapes, water streams, and lush greenery. Travelers booking a sedan cab in Pune can enjoy peaceful walks, photography, and a relaxing break from the city's busy environment."
  },
  {
    title: "Saras Baug",
    description: "Saras Baug is a popular garden in Pune known for its scenic surroundings and the famous Siddhivinayak Temple located inside. It is a favorite spot for families, morning walkers, and visitors looking for a calm and refreshing atmosphere."
  },
  {
    title: "Parvati Hill",
    description: "Parvati Hill is a historic site in Pune offering panoramic views of the city from its hilltop temples. Visitors can climb the steps to explore ancient shrines and enjoy breathtaking sunset views over Pune."
  },
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is a significant monument in Indian history associated with Mahatma Gandhi and the freedom movement. It features elegant architecture, spacious gardens, and a museum showcasing important historical artifacts."
  },

  {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is a historic fortification that was once the seat of the Peshwas. Visitors can explore its massive gates, ruins, and experience the light and sound show that narrates its glorious past."
  },
  {
    title: "Dagdusheth Halwai Ganpati Temple",
    description: "Dagdusheth Halwai Ganpati Temple is one of Pune’s most famous religious landmarks dedicated to Lord Ganesha. It attracts thousands of devotees daily and is especially vibrant during festivals."
  },
  {
    title: "Bund Garden",
    description: "Bund Garden is a peaceful riverside park offering greenery, walking paths, and boating activities. It is a popular place for relaxation and evening strolls in Pune."
  },
  {
    title: "Phoenix Marketcity Pune",
    description: "Phoenix Marketcity Pune is a leading shopping and entertainment destination featuring international brands, restaurants, cinemas, and entertainment zones for visitors of all ages."
  }
],



services: [
{
name: "Kandivali to Pune Cab Fare",
description: "Kandivali to Pune cab fare service offers transparent pricing and reliable taxi transportation between Kandivali in Mumbai and Pune city. Travelers can book comfortable vehicles such as sedan, Ertiga, and Innova depending on their travel needs and budget. The journey takes place through the Mumbai–Pune Expressway ensuring smooth and fast travel. Professional drivers provide punctual pickup services from Kandivali East and West, residential societies, offices, and hotels. This service is widely used for business trips, family travel, airport transfers, and weekend getaways. Air-conditioned vehicles and spacious seating ensure comfortable long-distance journeys. Online booking makes the process quick and convenient while offering clear fare details without hidden charges."
},
{
name: "Kandivali to Pune Station Cab Fare",
description: "Kandivali to Pune Station cab service provides dependable transportation between Kandivali and Pune Railway Station. Travelers can easily book taxis for comfortable travel through the Mumbai–Pune Expressway. Vehicles such as sedan, Ertiga, and Innova ensure smooth long-distance journeys with adequate luggage space. Professional drivers provide timely pickups from homes, offices, and hotels in Kandivali. This service is ideal for passengers connecting to train journeys from Pune station. Air-conditioned vehicles and experienced drivers ensure safe travel and punctual arrival. Online booking options provide instant confirmations and transparent fare details."
},
{
name: "Kandivali to Pune Pimpri Chinchwad Cab Fare",
description: "Kandivali to Pimpri Chinchwad cab service offers convenient transportation between Kandivali in Mumbai and the PCMC region of Pune. Travelers can choose comfortable vehicles including sedan, Ertiga, and Innova for smooth expressway travel. Professional drivers provide safe driving and punctual pickup services from Kandivali East and West. This service is widely used by corporate travelers visiting industrial zones and IT companies in Pimpri Chinchwad. Air-conditioned vehicles ensure comfortable long-distance travel while spacious seating provides convenience for passengers. Online booking ensures quick reservations with transparent fare pricing."
},
{
name: "Kandivali to Baner Taxi Fare",
description: "Kandivali to Baner taxi service provides reliable intercity transportation between Mumbai and the Baner area in Pune. Comfortable vehicles ensure smooth expressway travel with experienced drivers managing the long-distance route safely. Pickup services are available from residential complexes, offices, and hotels in Kandivali. This service is ideal for corporate travelers visiting Baner IT offices as well as families traveling to Pune. Air-conditioned vehicles and spacious seating make the journey comfortable. Transparent pricing helps travelers plan their trips easily while online booking ensures quick reservations."
},
{
name: "Kandivali to Pune by Taxi",
description: "Kandivali to Pune taxi service offers convenient intercity travel between the two cities with comfortable vehicles and professional drivers. Travelers can choose from sedan, Ertiga, and Innova vehicles depending on group size and comfort preferences. The journey through the Mumbai–Pune Expressway ensures fast and smooth travel. Professional drivers provide safe driving and punctual pickups from homes, offices, and hotels across Kandivali. This service is ideal for corporate travel, airport transfers, tourist visits, and family trips. Comfortable seating and air-conditioned interiors ensure a pleasant long-distance journey."
},
{
name: "Kandivali to Pune One Way Taxi Fare",
description: "Kandivali to Pune one way taxi service provides economical transportation for passengers who need a single-direction trip without paying for return fares. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth highway travel. Professional drivers provide timely pickup services from Kandivali East and West. This service is ideal for airport transfers, corporate travel, and personal visits to Pune. Air-conditioned vehicles and spacious seating make the journey comfortable. Transparent fare details and online booking ensure hassle-free travel planning."
},
{
name: "Kandivali to Pune Kondhwa Taxi",
description: "Kandivali to Kondhwa taxi service offers reliable transportation between Kandivali and the Kondhwa area of Pune. Travelers can enjoy comfortable rides in well-maintained vehicles such as sedan, Ertiga, and Innova. Professional drivers ensure safe expressway travel and punctual pickup services from residential and commercial areas in Kandivali. This service is ideal for business travelers and families visiting Kondhwa. Spacious seating and air-conditioned vehicles make long-distance travel comfortable. Online booking options allow passengers to easily schedule their journeys."
},
{
name: "Kandivali to Pune Innova Crysta Cab",
description: "Kandivali to Pune Innova Crysta cab service provides premium SUV travel for passengers seeking luxury and comfort. The Toyota Innova Crysta offers spacious seating, smooth suspension, and excellent highway performance. Travelers can enjoy comfortable rides with professional drivers who ensure safe driving and punctual pickups from Kandivali. This service is perfect for corporate travel, family trips, and group journeys. Air-conditioned interiors and ample luggage capacity ensure relaxed travel throughout the journey."
},
{
name: "Kandivali to Pune Kharadi Cab",
description: "Kandivali to Kharadi cab service provides reliable transportation between Kandivali in Mumbai and Pune’s IT hub Kharadi. Comfortable vehicles ensure smooth expressway travel while professional drivers provide safe driving and punctual pickup services. This service is widely used by corporate travelers and IT professionals traveling to Kharadi offices. Spacious seating and air-conditioned vehicles ensure comfortable long-distance journeys."
},
{
name: "Kandivali to Swargate Cab",
description: "Kandivali to Swargate cab service offers dependable transportation between Kandivali and central Pune. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth expressway travel with experienced drivers handling highway routes safely. This service is ideal for passengers traveling to Swargate bus station or nearby residential areas. Spacious seating and air-conditioned interiors ensure comfortable long-distance travel."
},
{
name: "Taxi Service in Kandivali Mumbai",
description: "Taxi service in Kandivali Mumbai provides convenient transportation for city travel, airport transfers, and outstation journeys. Travelers can choose from comfortable vehicles such as sedan, Ertiga, and Innova depending on travel needs. Professional drivers provide safe driving and punctual pickups from residential societies, offices, and hotels across Kandivali East and West. This service supports both local commuting and intercity trips to destinations like Pune, Nashik, and Lonavala."
},
{
name: "Kandivali to Pune Ertiga Taxi Fare",
description: "Kandivali to Pune Ertiga taxi service provides spacious 7-seater SUV transportation for families and small groups traveling between the two cities. The Maruti Ertiga offers comfortable seating, air-conditioning, and smooth highway performance. Professional drivers provide punctual pickups from Kandivali and ensure safe driving along the expressway. This service is ideal for airport transfers, corporate travel, and family journeys."
},
{
name: "Mumbai to Pune Taxi Fare",
description: "Mumbai to Pune taxi fare service provides clear pricing information for passengers traveling between the two cities. Travelers can choose from sedan, Ertiga, and Innova vehicles according to their comfort preferences and travel requirements. Professional drivers ensure safe driving and punctual pickups from homes, offices, and hotels across Mumbai. Smooth expressway travel ensures quick and reliable journeys. Transparent pricing allows passengers to plan their travel budget easily."
},
{
name: "Mumbai to Pune Car Rental",
description: "Mumbai to Pune car rental service provides comfortable vehicles with professional drivers for intercity travel. Travelers can choose from multiple vehicle options including sedan, Ertiga, and Innova depending on travel needs. The service offers flexible pickup locations across Mumbai including homes, offices, railway stations, and airport terminals. Smooth expressway travel ensures convenient journeys while spacious vehicles provide comfortable seating and luggage capacity."
},
{
name: "Mumbai to Pune Cab Charges",
description: "Mumbai to Pune cab charges service provides transparent fare details for travelers planning intercity taxi journeys. Passengers can select vehicles according to budget and comfort preferences. Clear pricing ensures no hidden charges and helps passengers plan their trips easily. Professional drivers ensure safe and smooth travel throughout the journey."
},
{
name: "Mumbai to Pune Cab Fare",
description: "Mumbai to Pune cab fare service offers economical transportation between the two cities with comfortable vehicles and experienced drivers. Travelers can book taxis from anywhere in Mumbai and enjoy smooth expressway travel to Pune. Air-conditioned vehicles and spacious seating ensure relaxed long-distance journeys."
},
{
name: "Mumbai to Pune Cab Booking",
description: "Mumbai to Pune cab booking service allows passengers to easily reserve taxis online for intercity travel. Travelers can select vehicle types, schedule pickup times, and receive instant booking confirmation. Professional drivers provide safe driving and reliable transportation."
},
{
name: "Cab Service in Mumbai",
description: "Cab service in Mumbai provides reliable taxi transportation for city travel, airport transfers, and outstation journeys. Travelers can book comfortable vehicles with experienced drivers for safe and convenient travel across the city and nearby destinations."
},
{
name: "Cab Booking Mumbai",
description: "Cab booking Mumbai service allows passengers to quickly reserve taxis for local rides, airport transfers, and long-distance travel. Online booking ensures easy scheduling and transparent fare details."
},
{
name: "Mumbai Taxi Service",
description: "Mumbai taxi service provides convenient transportation for passengers traveling within the city and to nearby destinations. Comfortable vehicles and professional drivers ensure smooth and reliable travel experiences."
},
{
name: "Cheapest Cab Service in Mumbai",
description: "Cheapest cab service in Mumbai offers affordable taxi transportation for passengers looking for budget-friendly travel options. Travelers can enjoy comfortable rides with transparent pricing and reliable drivers."
},
{
name: "Taxi Service in Kandivali",
description: "Taxi service in Kandivali provides convenient transportation for passengers traveling within Mumbai or heading to nearby destinations such as Pune. Comfortable vehicles and experienced drivers ensure safe and reliable journeys."
}
],

tableData: [
["Kandivali to Pune Cab Fare","Kandivali to Pune Station Cab Fare"],
["Kandivali to Pune Pimpri Chinchwad Cab Fare","Kandivali to Baner Taxi Fare"],
["Kandivali to Pune by Taxi","Kandivali to Pune One Way Taxi Fare"],
["Kandivali to Pune Kondhwa Taxi","Kandivali to Pune Innova Crysta Cab"],
["Kandivali to Pune Kharadi Cab","Kandivali to Swargate Cab"],
["Taxi Service in Kandivali Mumbai","Kandivali to Pune Ertiga Taxi Fare"],
["Mumbai to Pune Taxi Fare","Mumbai to Pune Car Rental"],
["Mumbai to Pune Cab Charges","Mumbai to Pune Cab Fare"],
["Mumbai to Pune Cab Booking","Cab Service in Mumbai"],
["Cab Booking Mumbai","Mumbai Taxi Service"],
["Cheapest Cab Service in Mumbai","Taxi Service in Kandivali"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly travel from Kandivali to Pune via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic conditions ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Kandivali to Pune cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Kandivali to Pune cab service operates 24 hours a day. Whether you need an early morning ride, airport transfer, or late night travel, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Kandivali to Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Kandivali",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and residential areas across Kandivali including Kandivali East, Kandivali West, and nearby locations."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Kandivali to Pune cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Kandivali to Pune cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Kandivali to Pune with professional drivers and comfortable vehicles." },
  { question: "How far is Kandivali from Pune?", answer: "The road distance between Kandivali and Pune is approximately 160 km and the journey usually takes about 3.5 to 4 hours depending on traffic." },
  { question: "Is Kandivali to Pune cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Kandivali to Pune travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Kandivali to Pune?", answer: "Yes, we provide both one-way and round-trip cab services between Kandivali and Pune." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, railway stations, and residential areas across Kandivali." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Kandivali to Pune cab services online or through phone booking." },
  { question: "Do you provide drop service to Pune Airport or railway station?", answer: "Yes, Velocity Cabs provides drop services to Pune Airport, railway stations, and major locations across Pune." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Aniket More",
    feedback:
      "Comfortable and hassle-free travel experience from Kandivali to Pune. The cab was punctual, well-maintained, and made the long journey very easy.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback:
      "Smooth arrangement for the Kandivali to Pune trip. The ride felt safe and relaxed, and the overall service was managed very professionally.",
    rating: 5
  }
];

































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kandivali to Pune Cab Service | Velocity Cabs",
  "description": "Velocity Cabs provides reliable Kandivali to Pune cab service with professional drivers and affordable fares. Book one way or round trip taxis including Innova, Innova Crysta, Ertiga, and Sedan cabs for city-to-city travel, airport transfers, and corporate trips. Enjoy safe, comfortable, and punctual rides with easy online booking from Kandivali to Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};




  return (
    <div>
      <Helmet>
  <title>Kandivali to Pune Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Kandivali to Pune cab with Velocity Cabs. Affordable one way & round trip taxis including Innova, Innova Crysta, Ertiga & Sedan for city travel, airport transfers & corporate trips." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/47.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Kandivalitopunecab;